module.exports = __webpack_public_path__ + "img/img_guide_01.3468121b.svg";